import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { selectAccountRole } from '../../../features/auth/ducks';
import { accountRoles } from '../../../common/enums';

const mapStateToProps = state => ({
  accountRole: selectAccountRole(state),
});

const mapDispatchToProps = dispatch => ({
  goTo: pathname => dispatch(push({ pathname })),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class DashboardIndexContainer extends Component {
  static propTypes = {
    accountRole: PropTypes.string.isRequired,
    goTo: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const { accountRole, goTo } = this.props;

    if (accountRole === accountRoles.DEBTOR) {
      goTo('dashboard/loans');
    } else if (accountRole === accountRoles.EXECUTOR) {
      goTo('dashboard/disposals');
    } else {
      goTo('dashboard/overview');
    }
  }

  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/DashboardIndexContainer.js